export default __webpack_public_path__ + "f8c85fed053bab19b25535c2f5cc3e44.png";